module.exports = __webpack_public_path__ + "img/loginQuoteImage03.1f3c28fe.webp";